//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const BASIC_API_AUTH_SIGNIN_USER = 'BASIC_API_AUTH_SIGNIN_USER';
export const BASIC_API_AUTH_SIGNIN_USER_SUCCESS = 'BASIC_API_AUTH_SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const USER_TOKEN_SET = 'user_token_set';
export const UPDATE_LOAD_USER = 'UPDATE_LOAD_USER';
export const SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';


export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

export const SETTING_SET_SODOR_DATE_FROM = 'SETTING_SET_SODOR_DATE_FROM';
export const SETTING_SET_SODOR_DATE_TO = 'SETTING_SET_SODOR_DATE_TO';